import { render, staticRenderFns } from "./EmployeeSummaryStatus.vue?vue&type=template&id=053c1d5a&scoped=true&lang=pug"
import script from "./EmployeeSummaryStatus.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryStatus.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSummaryStatus.vue?vue&type=style&index=0&id=053c1d5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c1d5a",
  null
  
)

export default component.exports